export default "__VITE_PUBLIC_ASSET__edd0d179__"